<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form [formGroup]="myTeamsAddEditForm">
      <div class="field-validation-error"></div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required" aria-required="true">
             <piqet-angular-common-input
              formControlName="teamName"
              [control]="myTeamsAddEditForm.get('teamName')"
              label="Team name"
              placeholder="Team name"
              [maxLength]="50"
              [submitted]="submitted"
            >
            </piqet-angular-common-input>
          </div>
        </div>
        <div class="col-sm-12" *ngIf="isHideDropDown">
          <div class="form-group required">
            <label
              *ngIf="myTeamsAddEditForm.get('organizationName')?.value"
              class="sub-header-drpdown pb-2"
              >Organization</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #organization
              [items]="organizationlist"
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationName"
              [searchFn]="commonInputSearch"
              placeholder="Organization *"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    placeholder="Search..."
                    (input)="organization.filter($any($event.target).value)"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (myTeamsAddEditForm.controls['organizationName']?.touched &&
                  myTeamsAddEditForm.controls['organizationName']?.invalid) ||
                myTeamsAddEditForm.controls['organizationName'].value?.name ===
                  '-- Select Organization -- ' ||
                (submitted && !myTeamsAddEditForm.controls['organizationName'].value?.name)
              "
              class="input-error"
            >
              Organization is required.
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer extraPadding">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
